import axios from "axios";
// import accessToken from "./jwt-token-access/accessToken";

//pass new generated access token here
const token = localStorage.getItem('authToken');

//apply base url for axios
// const API_URL = "http://localhost:300";
const API_URL = "https://matrix.expertcodecraft.com";

const axiosApi = axios.create({
    baseURL: API_URL,
});

axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.response.use(
    (response) => response,
    (error) => { throw error; } //Promise.reject(error)
);

export async function get(url, config = {}) {
    return await axiosApi
        .get(url, { ...config })
        .then((response) => response);
}

// export async function post(url, data, config = {}) {
// 	return axiosApi
// 		.post(url, { ...data }, { ...config })
// 		.then((response) => response);
// }

export async function post(url, data, config = {}) {
    const isFormData = data instanceof FormData;
    return axiosApi.post(
        url,
        isFormData ? data : { ...data },
        {
            ...config,
            headers: {
                ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                ...(config.headers || {}),
            },
        }
    );
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then((response) => response);
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then((response) => response);
}